.droc5z0 {
  background-color: #F2F1EF;
  font-family: Noto Sans JP Variable, sans-serif;
  color: #252525;
}
.droc5z1 {
  max-width: 540px;
  background-color: #F2F1EF;
}
.droc5z2 {
  margin: 0 0 120px;
  transform: rotate(90deg);
  transform-origin: bottom left;
  font-size: 13px;
  color: #858585;
}
.droc5z3 {
  position: relative;
  border-radius: 8px;
  background-color: white;
  color: #e63e27;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 12px;
  text-align: center;
  box-shadow: 0 2px 12px 1px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(2px);
}
.droc5z3:after {
  content: "";
  display: block;
  position: absolute;
  bottom: -8px;
  margin: 0 auto;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 10px solid white;
}
.droc5z4 {
  max-width: 540px;
  width: 100%;
  padding: 16px 24px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.droc5z5 {
  position: fixed;
  bottom: -200px;
  left: 50%;
  transform: translateX(-50%);
  transition: bottom 0.3s ease-in-out;
  z-index: 10;
}
.droc5z6 {
  bottom: 0;
}
@media (min-width: 960px) {
  .droc5z0 {
    height: 100vh;
    overflow-y: hidden;
  }
  .droc5z1 {
    width: 440px;
    height: 100%;
    overflow-y: scroll;
    margin: 80px 12px 0;
    border-radius: 40px 40px 0 0;
  }
  .droc5z7 {
    display: none;
  }
}
@media (max-width: 960px) {
  .droc5z2 {
    display: none;
  }
}